import React from 'react'
import styled from 'styled-components'
import Screen from './_Screen'
import {Wrapper, Title, Subtitle} from './Intro'

class Erroring extends React.Component
	render: ()->
		<Screen {@props...}>
			<Wrapper>
				<Icon>{"q"}</Icon>
				<Title>{"Uh Oh!"}</Title>
				<Subtitle>{"Something went wrong on our side of things... Press the retry button or try again later."}</Subtitle>
				
				{if @props.showRetry isnt false
					<Retry onClick={@retry.bind(@)}>
						<RetryButton>{"r"}</RetryButton>
						<RetryText>{"Try Again"}</RetryText>
					</Retry>
				else null}
			</Wrapper>
		</Screen>

	retry: ()->
		@props.submit()


Icon = styled.i"""
	display: block
	margin: 30px auto 20px
	font-size: 70px
	color: #e74c3d
"""

Retry = styled.div"""
	width: 100px
	margin: 70px auto 60px
	padding: 10px
	background-color: white
	border: 1px solid #dddddd
	border-radius: 5px
	cursor: pointer
	user-select: none
"""

RetryButton = styled.i"""
	font-size: 43px
	color: #fac40b
"""

RetryText = styled.div"""
	margin-top: 7px
	font-size: 11px
	font-family: gotham
	font-weight: 600
	text-transform: uppercase
	letter-spacing: 0.02em
"""



export default Erroring